import styled from 'styled-components';

export default styled.a`
  color: #ffe5a3;
`;
